import FilterTextField from '../baseInputTypes/FilterTextField'

export const ConfigurableSalesModel = () => {
  return (
    <FilterTextField
      label="Configurable Sales Model"
      fieldPath={'productInformation.configurableSalesModel'}
    />
  )
}
